//@ts-nocheck
import React from 'react';
import classNames from 'classnames';
import useDarkMode from '../../../hooks/useDarkMode';
import Footer from '../../../layout/Footer/Footer';
import { copyRightText } from '../../../helpers/helpers';

const DefaultFooter = () => {
	const { darkModeStatus } = useDarkMode();

	return (
		<Footer>
			<div className='container-fluid'>
				<div className='row p-2 align-middle'>
					<div className='col-sm footer-mobile-center footer-padding'>
						<span className='fw-light text-white'>{ copyRightText() }</span>
					</div>
					<div className='col-sm-auto footer-mobile-center mb-3 mb-md-0 mb-sm-0'>
						<a
							href="https://www.hashe.com" target="_blank" rel="noreferrer"
							className={classNames('text-decoration-none', {
								'link-dark': !darkModeStatus,
								'link-light': darkModeStatus,
							})}>
							<small className='text-white'>Hashe Computer Solutions (Pvt) Ltd</small>
						</a>
					</div>
				</div>
			</div>
		</Footer>
	);
};

export default DefaultFooter;
